import intl from "react-intl-universal";
import { cleanTaxIDMask, handleTaxIDLoginInput } from "../../../Utils/masks";

/**
 * Temporary FE bypass for Veriff face/liveness.
 * Keep in sync with MobileService FirstAccess:RequireLiveness (false = skip).
 * When re-enabling face, set this to false and RequireLiveness=true, then republish.
 */
export const FIRST_ACCESS_SKIP_LIVENESS = true;

export const normalizeFirstAccessInput = (value: string) =>
  handleTaxIDLoginInput(value);

export const prepareUsernameForApi = (value: string) => {
  const trimmed = value.trim();
  if (trimmed.includes("@")) return trimmed;
  return cleanTaxIDMask(trimmed);
};

export const validateFirstAccessUsername = (value: string): string | null => {
  const trimmed = value.trim();

  if (!trimmed) {
    return intl.get("auth.documentOrEmailRequired");
  }

  const isEmail = trimmed.includes("@");

  if (isEmail) {
    if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(trimmed)) {
      return intl.get("firstAccess.emailInvalid");
    }
    return null;
  }

  const digits = cleanTaxIDMask(trimmed);

  if (!/^\d+$/.test(digits)) {
    return intl.get("firstAccess.documentNumbersOnly");
  }

  if (![11, 14].includes(digits.length)) {
    return intl.get("firstAccess.documentInvalidLength");
  }

  return null;
};

export type PasswordRule = [passed: boolean, message: string];

export const getPasswordRules = ({
  password = "",
  confirmationPassword = "",
  transactionalPassword = "",
}): PasswordRule[] => [
  [password !== "", intl.get("firstAccess.passwordRequired")],
  [password.length >= 8, intl.get("firstAccess.passwordMinLength")],
  [
    confirmationPassword === password && !!confirmationPassword && !!password,
    intl.get("firstAccess.passwordsMustMatch"),
  ],
  [transactionalPassword !== "", intl.get("firstAccess.transactionalRequired")],
  [
    transactionalPassword.length === 4,
    intl.get("firstAccess.transactionalLength"),
  ],
  [
    !transactionalPassword || /^\d{4}$/.test(transactionalPassword),
    intl.get("firstAccess.transactionalNumbersOnly"),
  ],
];
